var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"activityImage-container",style:({ backgroundImage: _vm.activityData.images.bg ? `url(${_vm.activityData.images.bg})` : 'none' })})
}
var staticRenderFns = []

export { render, staticRenderFns }